import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { UserProperty } from '../../gateway/system/UserProperty'
import { InitialData, UserInfo } from '../../services'

export interface CommonState {
  pageTitle: string
  authenticationCode?: string
  userInfo?: UserInfo
  userProp?: UserProperty
  displayStartYear: string
  initialData: InitialData
  isLoading: boolean
  beforePageTitle?: string
}

const initialState: CommonState = {
  pageTitle: '',
  initialData: new InitialData(),
  isLoading: false,
  displayStartYear: ''
}

const commonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    setInitialData: (state, action: PayloadAction<InitialData>) => {
      state.initialData = action.payload
    },
    login: (state, action: PayloadAction<{ authenticationCode: string, userInfo?: UserInfo, userProp?: UserProperty }>) => {
      state.authenticationCode = action.payload.authenticationCode
      state.userInfo = action.payload.userInfo
      state.userProp = action.payload.userProp
    },
    logout: (state) => {
      state.authenticationCode = undefined
      state.userInfo = undefined
      state.userProp = undefined
    },
    setPageTitle: (state, action: PayloadAction<string>) => {
      state.pageTitle = action.payload
    },
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setBeforePageTitle: (state, action: PayloadAction<string>) => {
      state.beforePageTitle = action.payload
    },
    setDisplayStartYear: (state, action: PayloadAction<string>) => {
      state.displayStartYear = action.payload
    }
  }
})

export const CommonActions = commonSlice.actions
export const CommonReducers = commonSlice.reducer
